module.exports = __webpack_public_path__ + "static/img/neatoshop.com.53620f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/neatoshop.com.jpg
// module id = 38
// module chunks = 1